import Vue from 'vue'
import Vuex from 'vuex'
import Login from '@/stores/modules/Login'
import TopMenu from '@/stores/modules/TopMenu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Login,
    TopMenu
  }
})


// WEBPACK FOOTER //
// ./src/stores/index.js